import * as React from 'react';

function CultureIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M7.338 3.481c0 1.37-1.336 2.481-1.336 2.481s-1.335-1.11-1.335-2.48C4.667 2.111 6.002 1 6.002 1s1.336 1.11 1.336 2.481zM9.637 9.633C8.257 11.018 6 10.996 6 10.996s-.021-2.26 1.36-3.64C8.74 5.975 11 5.996 11 5.996s.018 2.26-1.363 3.637z"
        stroke="#fff"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M2.36 9.633C3.74 11.018 6 10.996 6 10.996s.02-2.26-1.36-3.64C3.259 5.975 1 5.996 1 5.996s-.021 2.26 1.36 3.637z"
        stroke="#fff"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.002 5.96v5.037"
        stroke="#fff"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CultureIcon;
